<template>
    <div style="padding-top:30px;">
        <div class="page-titles p-3 border-bottom">
            <h3 class="text-themecolor">Edit E-Mail Template
                <button class="btn btn-info btn-sm pull-right" @click="$router.push('/account/email-template')"><i class="far fa-envelope"></i> <span class="d-none d-sm-inline">E-Mail Templates</span></button>
            </h3>
        </div>
        <div class="container-fluid p-20" style="font-size: 0.75em;">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body p-4">
                            <form @submit.prevent="submit" @keydown="templateForm.errors.clear($event.target.name)">
                                <div class="form-group">
                                    <label for="">{{trans('template.subject')}}</label>
                                    <input class="form-control" type="text" value="" v-model="templateForm.subject" name="subject" :placeholder="trans('template.subject')">
                                    <show-error :form-name="templateForm" prop-name="subject"></show-error>
                                </div>
                                <div class="form-group">
                                  <autosize-textarea v-model="templateForm.body" rows="20" name="body"></autosize-textarea>
                                    <!-- <html-editor name="body" :model.sync="templateForm.body" isUpdate="true" @clearErrors="templateForm.errors.clear('body')"></html-editor> -->
                                    <show-error :form-name="templateForm" prop-name="body"></show-error>
                                </div>
                                <!-- <div class="help-block">{{trans('template.available_fields')}}: {{fields}}</div> -->
                                <button type="submit" class="btn btn-info waves-effect waves-light pull-right m-t-10">{{trans('general.save')}}</button>
                                <button type="button" class="btn btn-danger waves-effect waves-light pull-right m-t-10 m-r-10" @click="$router.push('/account/email-template')">{{trans('general.cancel')}}</button>
                            </form>

                          <div class="row" style="clear:both;">
                            <div class="col-12 col-sm-8">
                              <div class="form-group">
                                <label for="">Send Test E-Mail to:</label>
                                <input class="form-control" type="text" value="" v-model="templateEmailForm.email" name="subject" :placeholder="'E-Mail Address'">
                                <show-error :form-name="templateEmailForm" prop-name="email"></show-error>
                              </div>
                            </div>
                            <div class="col-12 col-sm-3">
                              <div class="form-group">
                                 <label for="">&nbsp;</label>
                                <select class="form-control" v-model="templateEmailForm.sender_id">
                                  <option value="">Sender</option>
                                  <option value="1">Lawin</option>
                                  <option value="2">Namo</option>
                                  <option value="3">Frank</option>
                                  <option value="5">Tad</option>
                                  <option value="4">Noreply</option>
                                </select>
                                <show-error :form-name="templateEmailForm" prop-name="sender_id"></show-error>
                              </div>
                            </div>
                            <div class="col-12 col-sm-1">
                              <div class="form-group">
                                <label for="">&nbsp;</label>
                                <button @click.prevent="sendTest" type="button" class="btn btn-info waves-effect waves-light" style="width:100%;">Send</button>
                              </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import htmlEditor from '../../components/html-editor'
    import autosizeTextarea from '../../components/autosize-textarea'

    export default {
        components : { htmlEditor, autosizeTextarea},
        data() {
            return {
                id:this.$route.params.id,
                templateForm: new Form({
                    subject: '',
                    body: '',
                }),
                templateEmailForm: new Form({
                  action: 'send_test',
                  email: '',
                  sender_id: '',
                }),
                fields: ''
            }
        },
        mounted(){
            if(!helper.hasPermission('list-user')){
                helper.notAccessibleMsg();
                this.$router.push('/account/dashboard');
            }

            if(!helper.featureAvailable('email_template')){
                helper.featureNotAvailableMsg();
                this.$router.push('/account/dashboard');
            }

            axios.get('/api/email-template/'+this.id)
                .then(response => response.data)
                .then(response => {
                    this.templateForm.subject = response.email_template.subject;
                    this.templateForm.body = response.email_template.body;
                    this.fields = response.fields;
                })
                .catch(error => {
                    helper.showDataErrorMsg(error);
                    this.$router.push('/account/email-template');
                })
        },
        methods: {
            submit(){
                this.templateForm.patch('/api/email-template/'+this.id)
                    .then(response => {
                        toastr.success(response.message);
                        this.$router.push('/account/email-template');
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            },
            sendTest(){
              this.templateEmailForm.post('/api/email-template/'+this.id+'/send')
                  .then(response => {
                    toastr.success(response.message);
                  })
                  .catch(error => {
                    helper.showErrorMsg(error);
                  });
            }
        }
    }
</script>
